import { useMemo } from 'react';
import type { FieldRendererProps } from '../../config/types';
import { Combobox, type ComboboxOption } from '@/components/ui/Combobox';
import { CURRENCIES } from './data';

export function CurrencySelectRenderer({ field, value, onChange, error, runtimeContext }: FieldRendererProps) {
  const suggested = runtimeContext.suggestedCurrency as string | undefined;

  const options: ComboboxOption[] = useMemo(() => {
    const base = CURRENCIES.map((c) => ({ value: c.value, label: c.label }));
    if (!suggested) return base;
    const idx = base.findIndex((c) => c.value === suggested);
    if (idx <= 0) return base;
    const [item] = base.splice(idx, 1);
    return [item, ...base];
  }, [suggested]);

  return (
    <Combobox
      options={options}
      value={(value as string) ?? ''}
      onValueChange={(v) => onChange(v)}
      placeholder={field.placeholder ?? 'Select currency...'}
      searchPlaceholder="Search currencies..."
      disabled={field.isDisabled}
      clearable
      className={`bg-surface-elevated ${error ? 'border-danger' : ''}`}
    />
  );
}
